import { render, staticRenderFns } from "./CardSplit.vue?vue&type=template&id=0da2f205&scoped=true"
import script from "./CardSplit.js?vue&type=script&lang=js&external"
export * from "./CardSplit.js?vue&type=script&lang=js&external"
import style0 from "./CardSplit.vue?vue&type=style&index=0&id=0da2f205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2f205",
  null
  
)

export default component.exports